import { BaseShortcut } from '@shared/directives/shortcuts/base-shortcut';
import { Directive, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Directive({
  selector: 'delete-shortcut-directive',
  outputs: [ 'deleteRequested']
})
export class DeleteShortcutDirective extends BaseShortcut {
  @Output() deleteRequested = new EventEmitter<any>();

  constructor(private _dialog: MatDialog) {
    super();
  }

  onKeyPress($event: KeyboardEvent): void {
    if (this._dialog.openDialogs && this._dialog.openDialogs.length > 0) {
      return;
    }

    // We want to ignore input to avoid deleting element when the editor wants to edit text...
    if (document.activeElement.nodeName === 'TEXTAREA' || document.activeElement.nodeName === 'INPUT') {
      return;
    }

    if ($event.code === 'Delete' ||  $event.code === 'Backspace') {
      this.deleteRequested.emit();
    }
  }

  filterEvent(event: any): void {}
}
